/**
 * Input Schema of Responsavel
 * @author Simpli CLI generator
 */
import {Component, FieldComponent, FieldSet, Schema} from 'simpli-web-sdk'
import {ResponsavelUsuario} from '@/model/resource/ResponsavelUsuario'

interface SchemaContext<T> {
  model: T
  fieldName: string
}

export class InputResponsavelUsuarioDefaultSchema extends Schema {
  readonly name = 'InputResponsavelUsuario'

  readonly fieldSet: FieldSet<ResponsavelUsuario> = {
    nome: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        model: schema.model.nome,
        label: this.translateFrom(schema.fieldName),
        validation: 'required',
      },
    }),
    email: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        model: schema.model.email,
        type: 'email',
        label: this.translateFrom(schema.fieldName),
        validation: 'required|email',
        required: true,
      },
    }),
    senha: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        model: schema.model.senha,
        type: 'password',
        label: this.translateFrom(schema.fieldName),
        validation: 'required|min:6',
        required: true,
      },
    }),
  }
}
